import { News } from './news.model';
import { Injectable, Injector } from '@angular/core';
import { AppApiInterface } from 'src/app/app.api';
import { map } from 'rxjs/operators';
import { BaseService } from 'src/app/shared/services/base.service';

@Injectable({ providedIn: 'root' })

export class NewsService extends BaseService<News>{

    constructor(
        protected injector:Injector,
    ){
        super(injector);
        this.copyJsonDataToObjectFunction=News.fromJsonToObject
        this.urls={getAllUrl:'posts',saveUrl:'regPost',updateUrl:'up-post',deleteUrl:'dst-post'}
    }

    getAllCategories() {
        return this.http.get<any>(`${AppApiInterface.IMALI_API}/categories`)
            .pipe(map(data => data))
    }

}